import * as types from './actionTypes.microphone';

export const stopMicrophone = () => ({
    type: types.STOP_MICROPHONE
});






